import React from 'react';

import clsx from 'clsx';

const westlakeIconSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
        <defs>
            <style>
            .st0{fill:#e51e2f;isolation:isolate;opacity:.3}.st1{fill:url(#SVGID_2_)}.st2{fill:#fff}.st3{fill:none;stroke:#a91f24;stroke-miterlimit:10;stroke-width:17px}
            </style>
            <radialGradient id="SVGID_2_" cx="294.4" cy="-1034.3" fx="294.4" fy="-1034.3" r="321" gradientTransform="translate(-51.6 -936.3) scale(1.2 -1.2)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#b92727"/>
            <stop offset=".3" stop-color="#a02526"/>
            <stop offset=".8" stop-color="#641318"/>
            <stop offset="1" stop-color="#531616"/>
            </radialGradient>
        </defs>
        <g id="westlake_logo">
            <path class="st1" d="M494.2,600H105.9c-58.1,0-105.3-47.2-105.3-105.5V105.5C.6,47.2,47.7,0,105.8,0h388.3c58.1,0,105.3,47.2,105.3,105.5v389c0,58.3-47.1,105.5-105.3,105.5Z"/>
            <path class="st3" d="M482.2,573.8H120.8c-52.5,0-95-42.6-95-95.2V116.5c0-52.6,42.6-95.2,95-95.2h358.5c52.5,0,95,42.6,95,95.2v364.9c0,51-41.2,92.3-92.1,92.3h0Z"/>
            <path class="st0" d="M0,197.1s300.9,108.6,599.8,0l.2-89.9s-.4-88.9-91.4-107.2L89.3.4S10,10.8,0,100.2v96.9h0Z"/>
            <path class="st2" d="M66.4,146.2h133v26.1h-15.2c-8.9,1.1-10.9,1.8-13.9,3.5-4.7,2.7-6.2,7.2-6.2,12.7s.3,11.3,2.9,19.9l63.6,186.4,55-181.1s-5.3-29.7-24.3-39.6c-4.8-1.1-14-1.6-25.6-.6v-27.3h138v27.3h-13.8c-9.9,0-16.5,1.3-19.9,3.8s-5.1,6.1-5.1,10.5c0,10.4,1.9,16.4,4.5,25.5l61,184.8,55.2-190.3c2.4-8.4,2.4-15.4,2.4-19.7s-1.6-8.6-4.8-11c-3.2-2.4-7.2-3.6-16.7-3.6h-19.3v-27.3h116.3v27.3c-15.1-.5-23.6.7-27.9,2.7s-7.8,4.8-10.5,8.4c-2.7,3.7-5.7,11.1-9,22.4l-90.5,294.9h-18.8l-77.4-237.4-75.9,237.1-15.2.3L109.2,203.5c-4.4-14.5-6.2-25.5-17.2-28.8-6.3-1.9-15.1-2.3-25.6-2.3v-26.1h0Z"/>
        </g>
    </svg>
`;

function WestlakeLogoIcon({ className }) {
    return (
        <span
            style={{ flexBasis: '32px', height: '32px' }}
            className={clsx(className, 'flex-shrink-0')}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: westlakeIconSVG }}
        />
    );
}

export default WestlakeLogoIcon;
